module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image1-81cd706f3cb167a5849091b4199c703f.png";